import styled from 'styled-components'
import { fullSizeAndAbsolute } from '@/styles/layout'
import { colors } from '@/styles/color'

export const FooterBackgroundContainer = styled.div`
  ${fullSizeAndAbsolute};
  overflow: hidden;
  background-color: ${colors.blue.dark};
`
